const MakeLocalStorage = () => {
    let CryptoJS = require("crypto-js");
    async function getData(url = '') {
        let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
        let originalText = bytes.toString(CryptoJS.enc.Utf8);
        const response = await fetch(url, {
            method: 'GET', 
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Token ${originalText}`
            },
        });

        return response ? response.json() : console.log('no reponse')
    };

    // getData('https://backendpajamas.herokuapp.com/drivers/').then( response => {
    //     localStorage.setItem('drivers', JSON.stringify(response.results))
    // })
    // getData('https://backendpajamas.herokuapp.com/schedule/').then( response => {
    //     localStorage.setItem('schedule', JSON.stringify(response.results))
    // })
    // getData('https://backendpajamas.herokuapp.com/images/').then( response => {
    //     localStorage.setItem('images', JSON.stringify(response.results))
    // })
}

export default MakeLocalStorage